import Component from '@glimmer/component';
import { type EventInfoComponentArgs } from 'donor-elf-web/components/event/index';
import formatDate from 'donor-elf-web/helpers/format-date';
import formatAmount from 'donor-elf-web/helpers/format-amount';

export default class EventInfoStoppedGivingDonorComponent extends Component<EventInfoComponentArgs> {
  <template>
    {{#if @eventModel.custom.pledge_first_gift_is_late}}
      They are over 3 months behind in giving towards their pledge. They were
      expected to give
      {{formatAmount
        @eventModel.custom.expected_donation_amount
        removeNoCents=true
      }}
      by
      {{formatDate @eventModel.custom.expected_donation_date}}.
    {{else}}
      It's been over 3 months since they last gave.
      {{#if @eventModel.custom.last_donation_date}}
        They last gave
        {{formatAmount @eventModel.custom.last_donation_amount removeNoCents=true}}
        on
        {{formatDate @eventModel.custom.last_donation_date}}
        and were expected to give their next donation on
        {{formatDate @eventModel.custom.expected_donation_date}}.
      {{/if}}
    {{/if}}
  </template>
}
